import {
  correcaoDescriptions,
  defasagemFixingBaseDescriptions,
  documentShortDescriptions,
  indexadorJurosFlutuantesDescriptions,
  indexadorRemuneracaoDescriptions,
  depositariaEmissaoDescriptions,
  negociacaoSecundariaDescriptions,
  percentualAmortizacaoDescriptions,
  periodicidadeCorrecaoDescriptions,
  tipoProjecaoDescriptions,
  tipoProRataDescriptions,
  tipoSerieDescriptions,
  tratamentoDescriptions,
  participanteDocumentShortDescriptions,
  tipoRepresentanteLegalDescriptions,
  tipoCargoDescriptions,
  tipoAcessoParticipanteDescriptions,
  investidorPfDocumentTypeDescriptions,
  investidorPjDocumentTypeDescriptions,
  funcaoParticipanteDescriptions,
  operacaoTipoDescriptions,
  bloqueioTipoDescriptions,
  motivoTransferenciaDescriptions,
  transferenciaTipoDescriptions,
  constricaoTipoDescriptions,
  eventoExtraordinarioTipoDescriptions,
  tipoInteroperabilidadeDescriptions,
  tipoInvestidorDescriptions,
  perfilDescriptions,
  debentureDocumentShortDescriptions,
  notaComercialDocumentShortDescriptions,
  emissaoStatusDescriptions,
  tipoPagamentoDescriptions,
  convencaoCalendarioPagamentoDescriptions,
  periodicidadeFluxoPagamentoDescriptions,
  grupoAcessoDescriptions,
  tipoCertidaoDescriptions,
  tipoDocumentoS3Descriptions,
  getInstrumentoFinanceiroLongDescription,
  contraparteRecebedoraDescriptions,
  tipoNotificacaoDescriptions,
  tipoDestinatariosDescriptions,
} from './genericDescriptions';
import {
  TipoDistribuicaoPublica,
  Moeda,
  Capitalizacao,
  ConvencaoJurosFixo,
  Convencao,
  FuncaoParticipante,
  IndexadorRemuneracao,
  DefasagemFixingBase,
  DefasagemFixingDiario,
  DefasagemFixingMensal,
  DefasagemFixingAnual,
  TipoProRata,
  CorrecaoJurosFixos,
  TratamentoValor,
  TratamentoFator,
  IndexadorJurosFlutuante,
  IndexadorAtualizacaoMonetaria,
  TipoProjecao,
  PeriodicidadeCorrecao,
  UploadDocumentType,
  Liquidacao,
  PercentualAmortizacao,
  ModalidadeAmortizacao,
  NegociacaoSecundaria,
  TipoSerie,
  DepositariaEmissao,
  ParticipanteUploadDocumentType,
  TipoRepresentanteLegal,
  TipoCargo,
  TipoAcessoParticipante,
  InvestidorDocumentType,
  OperacaoTipo,
  BloqueioTipo,
  MotivoTransferencia,
  Perfil,
  TransferenciaTipo,
  ConstricaoTipo,
  EventoExtraordinarioTipo,
  TipoInteroperabilidade,
  TipoInvestidor,
  DebentureUploadDocumentType,
  NotaComercialUploadDocumentType,
  TipoLiquidacao,
  EmissaoStatus,
  TipoPagamento,
  ConvencaoCalendarioPagamento,
  PeriodicidadeFluxoPagamento,
  GrupoAcesso,
  TipoCertidao,
  TipoDocumentoS3,
  InstrumentoFinanceiro,
  LaqusUserUploadDocumentType,
  InicioRentabilidadeEnum,
  ContraparteRecebedoraEnum,
  TipoFundo,
  TipoNotificacaoEnum,
  TipoDestinatariosEnum,
} from './genericTypes';

export interface Option {
  value: string;
  description: string;
}

export enum BooleanValue {
  Yes = 'SIM',
  No = 'NAO',
}

export const selectOption: Option = {
  value: '',
  description: 'Selecione',
};

export const booleanOptions: Option[] = [
  {
    value: BooleanValue.Yes,
    description: 'Sim',
  },
  {
    value: BooleanValue.No,
    description: 'Não',
  },
];

export const monthDayOptions = new Array(31).fill(0).map((_x, i) => ({
  value: i + 1,
  description: i + 1,
}));

export const months: { [key: number]: string } = {
  1: 'Janeiro',
  2: 'Fevereiro',
  3: 'Março',
  4: 'Abril',
  5: 'Maio',
  6: 'Junho',
  7: 'Julho',
  8: 'Agosto',
  9: 'Setembro',
  10: 'Outubro',
  11: 'Novembro',
  12: 'Dezembro',
};

export const monthOptions = new Array(12).fill(0).map((_x, i) => ({
  value: i + 1,
  description: months[i + 1],
}));

export const decimalPlacesOptions = new Array(30).fill(0).map((_x, i) => ({
  value: i + 1,
  description: i + 1,
}));

export const emissaoStatusOptions: Option[] = [
  ...Object.values(EmissaoStatus).map((value) => ({
    value: value,
    description: emissaoStatusDescriptions[value],
  })),
];

export const tipoInstrumentoOptions: Option[] = [
  ...Object.values(InstrumentoFinanceiro).map((value) => ({
    value: value,
    description: getInstrumentoFinanceiroLongDescription[value],
  })),
];

export const tipoSerieOptions: Option[] = [
  selectOption,
  ...Object.values(TipoSerie).map((value) => ({
    value,
    description: tipoSerieDescriptions[value],
  })),
];

export const negociacaoSecundariaOptions: Option[] = [
  ...Object.values(NegociacaoSecundaria).map((value) => ({
    value,
    description: negociacaoSecundariaDescriptions[value],
  })),
];

export const depositariaEmissaoOptions: Option[] = [
  ...Object.values(DepositariaEmissao).map((value) => ({
    value,
    description: depositariaEmissaoDescriptions[value],
  })),
];

export const tiposFundoOptions: Option[] = [
  selectOption,
  ...Object.values(TipoFundo).map((value) => ({
    value,
    description: value,
  })),
];

export const tipoDistribuicaoPublicaOptions: Option[] = [
  selectOption,
  ...Object.values(TipoDistribuicaoPublica).map((value) => ({
    value,
    description: value
  })),
];

export const contraparteRecebedoraOptions: Option[] = [
  selectOption,
  ...Object.values(ContraparteRecebedoraEnum).map((value) => ({
    value,
    description: contraparteRecebedoraDescriptions[value],
  })),
];

export const naturezaPessoaOptions: Option[] = [
  selectOption,
  {
    value: 'PF',
    description: 'PF',
  },
  {
    value: 'PJ',
    description: 'PJ',
  },
];

export const unidadeFederativaOptions: Option[] = [
  { value: '', description: 'Selecione' },
  { value: 'AC', description: 'AC' },
  { value: 'AL', description: 'AL' },
  { value: 'AP', description: 'AP' },
  { value: 'AM', description: 'AM' },
  { value: 'BA', description: 'BA' },
  { value: 'CE', description: 'CE' },
  { value: 'DF', description: 'DF' },
  { value: 'ES', description: 'ES' },
  { value: 'GO', description: 'GO' },
  { value: 'MA', description: 'MA' },
  { value: 'MT', description: 'MT' },
  { value: 'MS', description: 'MS' },
  { value: 'MG', description: 'MG' },
  { value: 'PA', description: 'PA' },
  { value: 'PB', description: 'PB' },
  { value: 'PR', description: 'PR' },
  { value: 'PE', description: 'PE' },
  { value: 'PI', description: 'PI' },
  { value: 'RJ', description: 'RJ' },
  { value: 'RN', description: 'RN' },
  { value: 'RS', description: 'RS' },
  { value: 'RO', description: 'RO' },
  { value: 'RR', description: 'RR' },
  { value: 'SC', description: 'SC' },
  { value: 'SP', description: 'SP' },
  { value: 'SE', description: 'SE' },
  { value: 'TO', description: 'TO' },
];

export const inicioRentabilidadeOptions: Option[] = [
  selectOption,
  {
    value: InicioRentabilidadeEnum.DATA_DE_EMISSAO,
    description: 'Data de Emissão',
  },
  {
    value: InicioRentabilidadeEnum.DATA_DE_INTEGRALIZACAO,
    description: 'Data de Integralização',
  }
];

export const moedaOptions: Option[] = [
  selectOption,
  {
    value: Moeda.BRL,
    description: Moeda.BRL,
  },
  {
    value: Moeda.USD,
    description: Moeda.USD,
  },
];

export const moedaOptionsNotaComercial: Option[] = [
  selectOption,
  {
    value: Moeda.BRL,
    description: Moeda.BRL,
  },
];

export const capitalizacaoOptions: Option[] = [
  selectOption,
  {
    value: Capitalizacao.Linear,
    description: 'Linear',
  },
  {
    value: Capitalizacao.Exponencial,
    description: 'Exponencial',
  },
];

export const convencaoJurosFixosOptions: Option[] = [
  selectOption,
  {
    value: ConvencaoJurosFixo.Actual30_360,
    description: '30/360 (%aa)',
  },
  {
    value: ConvencaoJurosFixo.Actual360,
    description: 'DC/360 (%aa)',
  },
  {
    value: ConvencaoJurosFixo.Actual365,
    description: 'DC/365 (%aa)',
  },
  {
    value: ConvencaoJurosFixo.Business252,
    description: 'DU/252 (%aa)',
  },
  {
    value: ConvencaoJurosFixo.Month_30,
    description: 'DC/30 (%am)',
  },
  {
    value: ConvencaoJurosFixo._30dc,
    description: '30dc (%am)',
  },
];

export const convencaoOptions: Option[] = [
  selectOption,
  {
    value: Convencao.DUP_252,
    description: 'dup/252',
  },
  {
    value: Convencao.DCP_360,
    description: 'dcp/360',
  },
  {
    value: Convencao.DCP_365,
    description: 'dcp/365',
  },
];

export const tipoLiquidacaoOptions: Option[] = [
  {
    value: TipoLiquidacao.Direta,
    description: 'Liquidação Direta',
  },
  {
    value: TipoLiquidacao.Cip,
    description: 'Liquidação Núclea',
  },
  {
    value: TipoLiquidacao.Fs,
    description: 'Liquidação Laqus Financial Services',
  },
  {
    value: TipoLiquidacao.B3,
    description: 'Liquidação B3',
  },
  {
    value: TipoLiquidacao.Outras,
    description: 'Outras Formas',
  }
];

export const tipoAcessoOptions: Option[] = [
  ...Object.values(TipoAcessoParticipante)
    .filter((categoria) => categoria !== TipoAcessoParticipante.Depositaria)
    .map((value) => ({
      value,
      description: tipoAcessoParticipanteDescriptions[value],
    })),
];

export const funcaoParticipanteOptions: Option[] = [
  ...Object.values(FuncaoParticipante).map((value) => ({
    value,
    description: funcaoParticipanteDescriptions[value],
  })),
];

export const indexadorRemuneracaoOptions: Array<Option> = [
  selectOption,
  ...Object.values(IndexadorRemuneracao).map((value) => ({
    value,
    description: indexadorRemuneracaoDescriptions[value],
  })),
];

export const defasagemFixingBaseOptions: Array<Option> = [
  ...Object.values(DefasagemFixingBase).map((value) => ({
    value,
    description: defasagemFixingBaseDescriptions[value],
  })),
];

export const defasagemFixingDiarioOptions: Array<Option> = [
  ...Object.values(DefasagemFixingDiario).map((value) => ({
    value,
    description: value,
  })),
];

export const defasagemFixingMensalOptions: Array<Option> = [
  ...Object.values(DefasagemFixingMensal).map((value) => ({
    value,
    description: value,
  })),
];

export const defasagemFixingAnualOptions: Array<Option> = [
  ...Object.values(DefasagemFixingAnual).map((value) => ({
    value,
    description: value,
  })),
];

export const tipoProRataOptions: Array<Option> = [
  selectOption,
  ...Object.values(TipoProRata).map((value) => ({
    value,
    description: tipoProRataDescriptions[value],
  })),
];

export const correcaoOptions: Option[] = [
  selectOption,
  ...Object.values(CorrecaoJurosFixos)?.map((value) => ({
    value,
    description: correcaoDescriptions[value],
  })),
];

export const tratamentoValorOptions: Option[] = [
  selectOption,
  ...Object.values(TratamentoValor)?.map((value) => ({
    value,
    description: tratamentoDescriptions[value],
  })),
];

export const tratamentoFatorOptions: Option[] = [
  ...tratamentoValorOptions,
  ...Object.values(TratamentoFator)?.map((value) => ({
    value,
    description: tratamentoDescriptions[value],
  })),
];

export const indexadorJurosFlutuanteOptions: Option[] = [
  selectOption,
  ...Object.values(IndexadorJurosFlutuante)?.map((value) => ({
    value,
    description: indexadorJurosFlutuantesDescriptions[value],
  })),
];

export const indexadorAtualizacaoMonetariaOptions: Option[] = [
  selectOption,
  ...Object.values(IndexadorAtualizacaoMonetaria)?.map((value) => ({
    value,
    description: value,
  })),
];

export const tipoProjecaoOptions: Option[] = [
  selectOption,
  ...Object.values(TipoProjecao)?.map((value) => ({
    value,
    description: tipoProjecaoDescriptions[value],
  })),
];

export const periodicidadeCorrecaoOptions: Option[] = [
  selectOption,
  ...Object.values(PeriodicidadeCorrecao)?.map((value) => ({
    value,
    description: periodicidadeCorrecaoDescriptions[value],
  })),
];

export const uploadDocumentsOptions: Option[] = [
  ...Object.values(UploadDocumentType)?.map((value) => ({
    value,
    description: documentShortDescriptions[value],
  })),
];

export const debentureUploadDocumentsOptions: Option[] = [
  ...Object.values(DebentureUploadDocumentType)?.map((value) => ({
    value,
    description: debentureDocumentShortDescriptions[value],
  })),
];

export const notaComercialUploadDocumentsOptions: Option[] = [
  ...Object.values(NotaComercialUploadDocumentType)?.map((value) => ({
    value,
    description: notaComercialDocumentShortDescriptions[value],
  })),
];

export const participanteUploadDocumentsOptions: Option[] = [
  ...Object.values(ParticipanteUploadDocumentType)?.map((value) => ({
    value,
    description: participanteDocumentShortDescriptions[value],
  })),
];

export const laqusUserUploadDocumentsOptions: Option[] = [
  ...Object.values(LaqusUserUploadDocumentType)?.map((value) => ({
    value,
    description: documentShortDescriptions[value],
  })),
]

export const liquidacaoOptions: Option[] = [
  selectOption,
  ...Object.values(Liquidacao)?.map((value) => ({
    value,
    description: value,
  })),
];

export const percentualAmortizacaoOptions: Option[] = [
  ...Object.values(PercentualAmortizacao)?.map((value) => ({
    value,
    description: percentualAmortizacaoDescriptions[value],
  })),
];

export const modalidadeAmortizacaoOptions: Option[] = [
  {
    value: ModalidadeAmortizacao.CUSTOMIZADO,
    description: 'Customizado',
  },
  {
    value: ModalidadeAmortizacao.SAC,
    description: 'SAC',
  },
  {
    value: ModalidadeAmortizacao.PRICE,
    description: 'Price',
  },
];

export const tipoRepresentanteLegalOptions: Option[] = [
  selectOption,
  ...Object.values(TipoRepresentanteLegal)
    ?.filter((tipo) => tipo !== TipoRepresentanteLegal.RepresentanteLegal)
    .map((value) => ({
      value,
      description: tipoRepresentanteLegalDescriptions[value],
    })),
];

export const tipoCargoOptions: Option[] = [
  selectOption,
  ...Object.values(TipoCargo)
    ?.filter((tipo) => tipo !== TipoCargo.RepresentanteLegal)
    .map((value) => ({
      value,
      description: tipoCargoDescriptions[value],
    })),
];

export const investidorPfDocumentTypeOptions: Option[] = [
  ...Object.values(InvestidorDocumentType)?.map((value) => ({
    value,
    description: investidorPfDocumentTypeDescriptions[value],
  })),
];

export const investidorPjDocumentTypeOptions: Option[] = [
  ...Object.values(InvestidorDocumentType)?.map((value) => ({
    value,
    description: investidorPjDocumentTypeDescriptions[value],
  })),
];

export const operacaoTipoOptions: Option[] = [
  ...Object.values(OperacaoTipo)?.map((value) => ({
    value,
    description: operacaoTipoDescriptions[value],
  })),
];

export const bloqueioTipoOptions: Array<Option> = [
  ...Object.values(BloqueioTipo)?.map((value) => ({
    value,
    description: bloqueioTipoDescriptions[value],
  })),
];

export const motivoTransferenciaOptions: Array<Option> = [
  ...Object.values(MotivoTransferencia).map((value) => ({
    value,
    description: motivoTransferenciaDescriptions[value],
  })),
];

export const transferenciaTipoOptions: Array<Option> = [
  ...Object.values(TransferenciaTipo).map((value) => ({
    value,
    description: transferenciaTipoDescriptions[value],
  })),
];

export const constricaoTipoOptions: Array<Option> = [
  ...Object.values(ConstricaoTipo)?.map((value) => ({
    value,
    description: constricaoTipoDescriptions[value],
  })),
];

export const eventoExtraordinarioTipoOptions: Array<Option> = [
  ...Object.values(EventoExtraordinarioTipo)?.map((value) => ({
    value,
    description: eventoExtraordinarioTipoDescriptions[value],
  })),
];

export const tipoInteroperabilidadeOptions: Array<Option> = [
  ...Object.values(TipoInteroperabilidade)?.map((value) => ({
    value,
    description: tipoInteroperabilidadeDescriptions[value],
  })),
];

export const tipoInvestidorOptions: Array<Option> = [
  ...Object.values(TipoInvestidor)?.map((value) => ({
    value,
    description: tipoInvestidorDescriptions[value],
  })),
];

export const perfilOptions: Array<Option> = [
  ...Object.values(Perfil)?.map((value) => ({
    value,
    description: perfilDescriptions[value],
  })),
];

export const grupoAcessoOptions: Array<Option> = [
  ...Object.values(GrupoAcesso)?.map((value) => ({
    value,
    description: grupoAcessoDescriptions[value],
  })),
];


export const tipoPagamentoOptions: Array<Option> = [
  selectOption,
  ...Object.values(TipoPagamento)?.map((value) => ({
    value,
    description: tipoPagamentoDescriptions[value],
  })),
];

export const convencaoCalendarioPagamentoOptions: Array<Option> = [
  ...Object.values(ConvencaoCalendarioPagamento)?.map((value) => ({
    value,
    description: convencaoCalendarioPagamentoDescriptions[value],
  })),
];

export const periodicidadeFluxoPagamentoOptions: Array<Option> = [
  ...Object.values(PeriodicidadeFluxoPagamento)?.map((value) => ({
    value,
    description: periodicidadeFluxoPagamentoDescriptions[value],
  })),
];

export const tipoCertidaoOptions: Array<Option> = [
  ...Object.values(TipoCertidao)?.map((value) => ({
    value,
    description: tipoCertidaoDescriptions[value],
  }))
];

export const tipoArquivoS3Options: Option[] = [
  ...Object.values(TipoDocumentoS3)?.map((value) => ({
    value,
    description: tipoDocumentoS3Descriptions[value],
  }))
];

export const tipoNotificacaoOptions: Array<Option> = [
  ...Object.values(TipoNotificacaoEnum)?.map((value) => ({
    value,
    description: tipoNotificacaoDescriptions[value],
  })),
];

export const tipoDestinatariosOptions: Array<Option> = [
  ...Object.values(TipoDestinatariosEnum)?.map((value) => ({
    value,
    description: tipoDestinatariosDescriptions[value],
  })),
];